export default __webpack_public_path__ + "static/media/dummy project image.5db5b08a.jpg";